(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["milora-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('milora-gallery')) {
    customElements.define('milora-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.buttons = [...this.querySelectorAll('[data-index]')];
        this.dots = [...this.querySelectorAll('.mi-gallery__dot')];
        this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.stage = this.querySelector('.mi-gallery__stage');
        this.rail = this.querySelector('.mi-gallery__thumbs');
        this.status = this.querySelector('.mi-gallery__status');
        this.rtl = getComputedStyle(this).direction === 'rtl';
        this.buttons.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.index)), options));
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.show(0);
          else if (event.key === 'End') this.show(this.slides.length - 1);
          else this.show(this.index + ((event.key === 'ArrowLeft') === this.rtl ? 1 : -1));
          if (event.target.closest('.mi-gallery__thumb')) this.buttons[this.index]?.focus({ preventScroll: true });
        }, options);
        this.stage.addEventListener('touchstart', event => {
          this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        this.stage.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) this.show(this.index + ((dx > 0) === this.rtl ? 1 : -1));
        }, { ...options, passive: true });
        this.stage.addEventListener('touchcancel', () => { this.touch = null; }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.touch = null;
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        if (this.status) this.status.textContent = this.slides[this.index].querySelector('img')?.alt || '';
        if (!this.rail || !this.buttons[this.index]) return;
        const rail = this.rail.getBoundingClientRect();
        const button = this.buttons[this.index].getBoundingClientRect();
        const shift = button.left < rail.left ? button.left - rail.left : button.right > rail.right ? button.right - rail.right : 0;
        if (shift) this.rail.scrollBy({ left: shift, behavior: 'auto' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["milora-offer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('milora-offer'))customElements.define('milora-offer',class extends HTMLElement{
connectedCallback(){
  if(this.ready)return;
  this.ready=true;
  this.form=this.querySelector('form');
  this.submit=this.querySelector('[type=submit]');
  this.label=this.querySelector('[data-submit-label]');
  this.error=this.querySelector('[role=alert]');
  this.mode='single';
  this.price=Number(this.dataset.singlePrice);
  this.compare=Math.max(this.price,Number(this.dataset.singleCompare));
  this.querySelectorAll('[name=milora_choice]').forEach(r=>{r.disabled=false;r.addEventListener('change',()=>{if(r.checked){this.mode=r.value;this.update()}})});
  const select=this.querySelector('select[name=id]');
  if(select)select.addEventListener('change',()=>{this.price=Number(select.selectedOptions[0].dataset.price);this.compare=Math.max(this.price,Number(select.selectedOptions[0].dataset.compare));this.renderPrices();this.update()});
  this.form.addEventListener('submit',e=>this.add(e));
  this.updatePromotion();
  const connectSticky=()=>{
    const sticky=document.querySelector('sticky-atc');
    const button=sticky?.querySelector('.sticky-atc__add_button');
    if(!sticky||!button)return false;
    this.observer=new IntersectionObserver(entries=>entries.forEach(e=>sticky.classList.toggle('mi-offer-sticky-visible',!e.isIntersecting&&e.boundingClientRect.bottom<0)));
    this.observer.observe(this.form);
    this.stickyButton=button;
    this.onStickyClick=e=>{e.preventDefault();e.stopImmediatePropagation();this.submit.click()};
    button.addEventListener('click',this.onStickyClick,true);
    return true;
  };
  if(!connectSticky()){
    this.stickyFinder=new MutationObserver(()=>{if(connectSticky())this.stickyFinder.disconnect()});
    this.stickyFinder.observe(document.documentElement,{childList:true,subtree:true});
  }
}
disconnectedCallback(){this.observer?.disconnect();this.stickyFinder?.disconnect();this.stickyButton?.removeEventListener('click',this.onStickyClick,true);clearTimeout(this.promoTimer)}
money(value){return new Intl.NumberFormat(this.dataset.locale||'he-IL',{style:'currency',currency:this.dataset.currency||'ILS',maximumFractionDigits:2,minimumFractionDigits:0}).format(value/100)}
renderPrices(){
  for(const selector of ['[data-main-price]','[data-single-total]'])this.querySelector(selector).textContent=this.money(this.price);
  for(const selector of ['[data-main-compare]','[data-single-compare]']){const element=this.querySelector(selector);element.textContent=this.money(this.compare);element.hidden=this.compare<=this.price}
  const percent=this.compare>0?Math.round((this.compare-this.price)*100/this.compare):0;
  const discount=this.querySelector('[data-discount]');discount.textContent=this.dataset.discountLabel.replace('__PERCENT__',String(percent));discount.hidden=percent<=0;
  const total=this.querySelector('[data-bundle-total]');
  if(total){const price=this.dataset.bundleId?Number(this.dataset.bundlePrice):this.price+Number(this.dataset.extrasPrice);const compare=this.compare+Number(this.dataset.extrasCompare);total.textContent=this.money(price);const comparison=this.querySelector('[data-bundle-compare]');comparison.textContent=this.money(compare);comparison.hidden=compare<=price;const reference=this.querySelector('[data-bundle-reference]');reference.textContent=this.money(compare);reference.parentElement.hidden=compare<=price;const saving=this.querySelector('[data-bundle-saving]');saving.textContent=this.money(compare-price);saving.parentElement.hidden=compare<=price}
  this.updatePromotion();
}
updatePromotion(){
  clearTimeout(this.promoTimer);
  const end=Date.parse(this.dataset.promoEnd);
  const remaining=end-Date.now();
  const active=Number.isFinite(end)&&remaining>0&&this.compare>this.price;
  if(this.promotionWasActive&&remaining<=0){window.location.reload();return}
  this.promotionWasActive=active;
  this.querySelector('[data-deadline]').hidden=!active;
  this.querySelector('[data-promo-heading]').hidden=!active;
  this.querySelector('[data-regular-heading]').hidden=active;
  if(active){const date=new Intl.DateTimeFormat('he-IL',{timeZone:'Asia/Jerusalem',day:'numeric',month:'numeric',year:'numeric',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(new Date(end));this.querySelector('[data-deadline-text]').textContent=this.dataset.deadlineLabel.replace('__DATE__',date);this.promoTimer=setTimeout(()=>this.updatePromotion(),Math.min(remaining,60000))}
}
update(){this.label.textContent=this.dataset.addLabel+(this.dataset.showButtonPrice==='true'?' — '+this.money(this.mode==='bundle'?(this.dataset.bundleId?Number(this.dataset.bundlePrice):this.price+Number(this.dataset.extrasPrice)):this.price):'')}
async add(event){
  event.preventDefault();if(this.busy||this.submit.disabled)return;this.busy=true;this.submit.disabled=true;this.label.textContent=this.dataset.adding;this.error.hidden=true;
  let added=false;const root=window.Shopify?.routes?.root||'/';const items=[{id:Number(this.mode==='bundle'&&this.dataset.bundleId?this.dataset.bundleId:this.form.elements.id.value),quantity:1}];
  if(this.mode==='bundle'&&!this.dataset.bundleId)for(const key of ['ball','band','handles'])items.push({id:Number(this.dataset[key]),quantity:1});
  try{const drawer=document.querySelector('cart-drawer');let sections=['cart-drawer','cart-icon-bubble'];if(drawer?.getSectionsToRender)sections=drawer.getSectionsToRender().map(s=>s.id);const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections,sections_url:window.location.pathname})});const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||this.dataset.error);added=true;if(drawer?.renderContents&&data.sections){drawer.classList.remove('is-empty');if(drawer.setActiveElement)drawer.setActiveElement(this.submit);drawer.renderContents(data);if(drawer.open)drawer.open()}else window.location.assign(root+'cart')}
  catch(error){if(added){window.location.assign(root+'cart');return}this.error.textContent=this.dataset.error;this.error.hidden=false}
  finally{this.busy=false;this.submit.disabled=false;this.update()}
}
});
  } catch(e) { console.error(e); }
})();

})();
